const getters = {
    getWait: state => (actionName) => state[actionName]
};
function createState(actions) {
    return actions.reduce((obj, value) => {
        obj[value] = false;
        return obj;
    }, {});
}
function createMutations(actions) {
    return actions.reduce((obj, value) => {
        obj[value] = (state, payload) => {
            state[value] = payload;
        };
        return obj;
    }, {});
}
function createModule(actions, options) {
    return {
        namespaced: options.namespaced,
        state: createState(actions),
        getters,
        mutations: createMutations(actions)
    };
}
export default (store, options) => {
    const { vuexModuleName } = options;
    const actions = Object.keys(store._actions);
    store.registerModule(vuexModuleName, createModule(actions, options));
    store.subscribeAction({
        before(action) {
            store.commit(`${vuexModuleName}/${action.type}`, true);
        },
        after(action) {
            store.commit(`${vuexModuleName}/${action.type}`, false);
        },
        error(action) {
            store.commit(`${vuexModuleName}/${action.type}`, false);
        }
    });
};
//# sourceMappingURL=main.js.map